import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "toggle-info",
    style: _normalizeStyle({
    background: $props.value ? 'var(--semantic-color-primary-default, #8300C7)' : 'var(--semantic-color-bg-muted, #E6E4EB)',
    justifyContent: $props.value ? 'flex-end' : 'flex-start',
  }),
    onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('change', !$props.value))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("div", { class: "circle-data" }, null, -1 /* HOISTED */)
  ]), 4 /* STYLE */))
}